/** A key as a keyboard hint shows it: a small key cap. */
export const KBD_CLASS =
  "rounded border bg-muted px-1.5 py-0.5 font-mono text-[11px] text-muted-foreground";
